import 'dayjs/locale/pt-br';
import { Calendar } from '@mantine/dates';
import { Button, Container, Group } from '@mantine/core';
import { FirstDayOfWeek } from '@mantine/dates/lib/types';

interface CustomCalendarProps {
  value: Date[];
  minDate?: Date;
  onChange(value: Date[]): void;
  firstDayOfWeek?: FirstDayOfWeek;
}

export function CustomCalendar(props: CustomCalendarProps) {
  return (
    <Container>
      <Calendar locale="pt-br" multiple fullWidth {...props} />
      <Group position="left">
        <Button onClick={() => props.onChange([])} variant="subtle">
          limpar
        </Button>
      </Group>
    </Container>
  );
}
